import { NgModule } from "@angular/core";
import { CoreModule } from "../../core/core.module";
import { SharedModule } from "../../shared/shared.module";
import { AssetModule } from "./assets/asset.module";
import { CompanyModule } from "./companies/company.module";
import { CompanyAttachmentModule } from "./company-attachments/company-attachment.module";
import { ConfigurableOptionModule } from "./configurable-options/configurable-options.module";
import { ContractModule } from "./contracts/contract.module";
import { DashboardModule } from "./dashboard/dashboard.module";
import { InternalProviderModule } from "./internal-provider/internal-provider.module";
import { LocationModule } from "./locations/location.module";
import { MaintenanceProviderModule } from "./maintenance-provider/maintenance-provider.module";
import { PartnerModule } from "./partners/partner.module";
import { PortalRoutingModule } from "./portal-routing.module";
import { PortalComponent } from "./portal.component";
import { ProfileModule } from "./profile/profile.module";
import { QuoteModule } from "./quotes/quote.module";
import { ReportingModule } from "./reporting/reporting.module";
import { SidebarModule } from "./sidebar/sidebar.module";
import { TicketModule } from "./tickets/ticket.module";
import { UserModule } from "./users/user.module";

@NgModule({
  declarations: [PortalComponent],
  imports: [
    AssetModule,
    CompanyModule,
    CompanyAttachmentModule,
    ContractModule,
    DashboardModule,
    InternalProviderModule,
    LocationModule,
    MaintenanceProviderModule,
    PartnerModule,
    ProfileModule,
    QuoteModule,
    ReportingModule,
    TicketModule,
    UserModule,
    ConfigurableOptionModule,
    SidebarModule,
    PortalRoutingModule,
    CoreModule,
    SharedModule,
  ],
  exports: [
    PortalComponent,
    AssetModule,
    CompanyModule,
    CompanyAttachmentModule,
    ContractModule,
    DashboardModule,
    InternalProviderModule,
    LocationModule,
    MaintenanceProviderModule,
    PartnerModule,
    ProfileModule,
    QuoteModule,
    ReportingModule,
    TicketModule,
    UserModule,
    ConfigurableOptionModule,
    SidebarModule,
    PortalRoutingModule,
  ],
})
export class PortalModule {}
